import { QaPairs } from '../types/common-items';

export const UPDATE_QA_PAIRS = 'UPDATE_QA_PAIRS';

export const updateQaPairs = (payload: QaPairs) => ({
    type: UPDATE_QA_PAIRS,
    payload,
});

export default (state = [] as QaPairs, action: ReturnType<typeof updateQaPairs>) =>
    action.type === UPDATE_QA_PAIRS ? action.payload : state;
